<template>
  <section>
    <div class="tip" style="margin:25px 0 0 20px">* 项目基本资料</div>
    <ul class="project-info-list" v-if="project">
      <li>
        <label>项目/合同名称：</label>
        <div class="info-item">{{ project.name }}</div>
      </li>
      <li>
        <label>项目编号：</label>
        <div class="info-item">{{ project.number }}</div>
      </li>
      <li>
        <label>立项批文号：</label>
        <div class="info-item">{{ project.lxpwh }}</div>
      </li>
      <li>
        <label>项目需求单位：</label>
        <div class="info-item">{{ project.deptName }}</div>
      </li>
      <li>
        <label>项目负责人：</label>
        <div class="info-item">{{ project.leader.name }}</div>
      </li>
      <li>
        <label>联系方式：</label>
        <div class="info-item">{{ project.leader.mobile }}</div>
      </li>


      <li>
        <label>建设性质：</label>
        <div class="info-item">{{ form.jsxz }}</div>
      </li>
      <li>
        <label>工程专业：</label>
        <div class="info-item">{{ form.gczy }}</div>
      </li>
      <li class="block intro-box">
        <label>批复的工程建设规模：</label>
        <div class="info-item">{{ form.gcjsgm }}</div>
      </li>
    </ul>
    <div class="tip" style="margin:0 0 0 20px">* 工程经济及单位信息</div>
    <ul class="project-info-list" v-if="form.type!=2">
      <li>
        <label>总投资(元)：</label>
        <div class="info-item">{{ form.ztz }}</div>
      </li>
      <li>
        <label>建安工程费(元)：</label>
        <div class="info-item">{{ form.jagcf }}</div>
      </li>
      <li>
        <label>招标控制价(元)：</label>
        <div class="info-item">{{ form.zbkzj }}</div>
      </li>
      <li>
        <label>甲供材料(元)：</label>
        <div class="info-item">{{ form.jgcl }}</div>
      </li>
    </ul>
    <ul class="project-info-list" v-else>
      <li>
        <label>建安费(元)：</label>
        <div class="info-item">{{ form.jaf }}</div>
      </li>
      <li>
        <label>招标控制价(元)：</label>
        <div class="info-item">{{ form.zbkzj }}</div>
      </li>
      <li>
        <label>甲供材料(元)：</label>
        <div class="info-item">{{ form.jgcl }}</div>
      </li>
    </ul>
    <ul class="project-info-list">
      <li>
        <label>设计单位：</label>
        <div class="info-item">{{ form.sjdw }}</div>
      </li>
      <li>
        <label>控制价编制单位：</label>
        <div class="info-item">{{ form.bzdw }}</div>
      </li>
      <li class="block">
        <label>工程定额：</label>
        <div class="info-item">{{ form.gcde }}</div>
      </li>

      <li>
        <label>计价方式：</label>
        <div class="info-item">{{ form.jjfs }}</div>
      </li>
      <li>
        <label>投标方式：</label>
        <div class="info-item">{{ form.tbfs }}</div>
      </li>
      <li class="block">
        <label>价格信息：</label>
        <div class="info-item">{{ form.jgxx }}</div>
      </li>
    </ul>




  </section>
</template>
<script>
  export default {
    props: ['form', 'userData', 'project'],
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>


// WEBPACK FOOTER //
// src/page/user/projectinfo/createInvite.vue